// src/components/MakeenLogo.jsx
import React from 'react';

const MakeenLogo = ({ language, variant = 'header' }) => {
  const isFooter = variant === 'footer';
  const logoSrc = '/logo.png'; // logo.png should be inside the public folder

  return (
    <div className={`flex flex-col items-start cursor-pointer ${isFooter ? 'opacity-90' : 'opacity-100'}`}>
      <img 
        src={logoSrc} 
        alt={language === 'ar' ? 'مكين - البنك الرقمي' : 'Makeen Digital Bank'} 
        className={`h-10 w-auto ${isFooter ? 'opacity-90' : 'opacity-100'}`}
      />
      {/* Optional subtitle below logo */}
      <div 
        className={`text-xs font-medium mt-1 ${isFooter ? 'opacity-90' : 'opacity-80'}`}
        style={{
          fontFamily: language === 'ar' ? 'GE SS Two, Arial, sans-serif' : 'Poppins, sans-serif',
          letterSpacing: language === 'ar' ? '0.1em' : '0.15em'
        }}
      >
      </div>
    </div>
  );
};

export default MakeenLogo;
